export default __webpack_public_path__ + "static/media/EQSTK.8adbea47.png";